import api from "../api/api";

export const AdService = {
  /**
   * Aktiv reklamlar. merchantId verilsə yalnız həmin mağazanın reklamları,
   * verilməsə ana səhifə üçün bütün aktiv reklamlar qaytarılır.
   * Başlıq və məzmun {az,en,ru} obyektidir — dili front seçir.
   */
  list: async ({ merchantId, limit } = {}) => {
    const response = await api.get("ads", {
      params: {
        ...(merchantId ? { merchant_id: merchantId } : {}),
        ...(limit ? { limit } : {}),
      },
    });
    return response.data; // { ads: [...] }
  },
};
